module.exports = __webpack_public_path__ + "static/media/anish.c88618ae.jpg";